/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 监管动态----监管文件
 */
import React from 'react';
import { Table } from 'antd';
import { LettersTypeText } from '../../../../constants/info';
import { dateFormat, fieldAnomaly } from '../../../../utils/formatter';
import Pagination from '../../../common/pagination/Pagination';
import TableSearch from '../../../common/tableSearch/TableSearch';
import OuterUrlLink from '../../../common/outerUrlLink/OuterUrlLink';
import SearchForm from './file/SearchForm';
import { dynamicLetter } from '../../../../services/regulatoryStatistical';

export default class File extends TableSearch {
    constructor(props) {
        super(props);
        this.server = dynamicLetter;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            loading: true,
            data: []
        };
    }

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 110
        }, {
            title: '公司简称',
            dataIndex: 'sesName',
            width: 120
        }, {
            title: '公司全称',
            dataIndex: 'companyName'
        }, {
            title: '公布日期',
            dataIndex: 'pubDate',
            width: 150,
            render: dateFormat
        }, {
            title: '函件类别',
            dataIndex: 'pubnishType',
            width: 180,
            render: (v) => fieldAnomaly(LettersTypeText[v])
        }, {
            title: '相关链接',
            dataIndex: 'linkUrl',
            width: 260,
            render: (v) => <OuterUrlLink url={v}/>
        }];
    };

    render() {
        const { options } = this.props;
        const { pageNum, pageSize, total, data, loading } = this.state;
        return (
            <div>
                <SearchForm options={options} onSearch={this.onSearch}/>

                <Table
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/state/File.jsx